export const isInBinance = () => {
  try {
    return (window as any)?.ethereum?.isBinance === true
  } catch (error) {
    return false
  }
}

export const isExtensionInstalled = (): boolean => {
  try {
    return (window as any)?.binancew3w?.isExtension === true
  } catch (error) {
    return false
  }
}
